import { StyledCustomImage } from './style';
import { useState } from 'react';
import { RcFile, UploadFile } from 'antd/es/upload/interface';
import { useIntl } from 'react-intl';
import { FallbackImage } from '../fallBack/FallBackImage';
import { Radio } from '../../Radio';
import { CropperModal } from 'ui/CropperModal';

interface CustomImageProps {
  file: UploadFile;
  onRemove: (file: UploadFile) => void;
  onEdit: (file: UploadFile) => void;
  showActions?: boolean;
  aspectRatio?: number;
  selectedImageName?: string;
  setSelectedImageName?: React.Dispatch<
    React.SetStateAction<string | undefined>
  >;
  selectable: boolean | undefined;
  showDefault?: boolean;
}

export const CustomImage = ({
  file,
  onEdit,
  onRemove,
  showActions = true,
  aspectRatio,
  selectedImageName,
  setSelectedImageName,
  selectable,
  showDefault,
}: CustomImageProps) => {
  const [cropperVisible, setCropperVisible] = useState(false);
  const [cropImage, setCropImage] = useState<string | undefined>(undefined);

  const handleEdit = () => {
    setCropImage(file.url ?? file.preview);
    setCropperVisible(true);
  };

  const handleCropComplete = (croppedFile: File) => {
    const rcFile = new File([croppedFile], file.name, {
      type: croppedFile.type,
      lastModified: croppedFile.lastModified,
    }) as RcFile;

    rcFile.uid = `${Date.now()}-${Math.random()}`;

    const uploadFile: UploadFile = {
      uid: rcFile.uid,
      name: rcFile.name,
      status: 'done',
      url: URL.createObjectURL(croppedFile),
      originFileObj: rcFile,
    };
    onRemove(file);
    onEdit(uploadFile);
    setCropperVisible(false);
  };

  const intl = useIntl();

  const handleRemove = () => {
    onRemove(file);
  };

  return (
    <StyledCustomImage>
      <div className={'custom-upload-list-item'}>
        {selectable && (
          <div className={'overlay-wrap'}>
            <div className={'overlay'}>
              <Radio
                className={'checkbox-thumbnail'}
                checked={selectedImageName === file.name}
                onChange={() => {
                  if (setSelectedImageName) {
                    setSelectedImageName(file.name);
                  }
                }}
                value={file.uid}
                label={intl.formatMessage({ id: 'images.thumbnail' })}
              />
            </div>
          </div>
        )}
        <FallbackImage
          src={file.url ?? file.preview}
          type={'ProductCard'}
          className={'custom-upload-list-item-image'}
          preview={true}
          showDefault={showDefault}
        />
        {showActions && (
          <div className="custom-upload-list-item-actions">
            <div className="action" onClick={() => handleEdit()}>
              {intl.formatMessage({ id: 'general.edit' })}
            </div>
            <div onClick={() => handleRemove()} className={'action'}>
              {intl.formatMessage({ id: 'general.delete' })}
            </div>
          </div>
        )}
      </div>
      {cropImage && file && (
        <CropperModal
          file={file}
          visible={cropperVisible}
          image={cropImage}
          onCancel={() => setCropperVisible(false)}
          onCropComplete={handleCropComplete}
          aspectRatio={aspectRatio}
        />
      )}
    </StyledCustomImage>
  );
};
